import React from 'react';
import Otherindex from './Otherindex';

import './parent.scss';

export default class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    };

  render() {
    const { auth } = this.props;
    const { domain } = auth;
    return (
        <div className="dash-external-container">
                <Otherindex {...this.props}/>
        </div>
    );
  }
}

